import React from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';

const { Option } = Select;

export default class UserRemoteSelect extends React.Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);

    this.fetchUser = this.fetchUser.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      data: [],
      value: props.defaultOptions || [],
      fetching: false,
    };
  }



  fetchUser = value => {
    console.log('fetching user', value);
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true });
    // fetch('https://randomuser.me/api/?results=5')
    // debugger
    fetch(Biscraft.routes.users_path + "?q=" + value)
    
      .then(response => response.json())
      .then(body => {
        if (fetchId !== this.lastFetchId) {
          // for fetch callback order
          return;
        }
        const data = body.map(user => ({
          text: `${String(user.name)} (${String(user.email)})`,
          value: user.id,
        }));
        this.setState({ data, fetching: false });
      });
  };

  handleChange = value => {
    console.log("value")
    console.log(value)
    this.setState({
      value,
      data: [],
      fetching: false,
    });

    if (this.props.setIdsToHiddenField && value) {
      const ids = value.map(v => v.key).join(",")
      $(this.props.setIdsToHiddenField).val(ids)
    }

  };

  render() {

    const { fetching, data, value } = this.state;
    return (
      <Select
        mode="multiple"
        labelInValue
        value={value}
        placeholder="Select users"
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        onSearch={this.fetchUser}
        onChange={this.handleChange}
        style={{ width: '100%' }}
      >
        {data.map(d => (
          <Option key={d.value}>{d.text}</Option>
        ))}
      </Select>
    );
  }
}